export interface PersonalAccessToken {
  personalAccessTokenId: string;
  publicId: string;
  name: string;
  environment: string;
  createDate: string;
  creator?: string;
  lastUsedDate?: string;
  revokeDate?: string;
  revoker?: string;
  scopes: string[];
  expireDate?: string;
  userId: string;
  rightId: string;
  profileCode?: string;
  perimeterType?: string;
  perimeterId: string;
  perimeterName?: string;
}

export interface PersonalAccessTokenEligibleRight {
  rightId: string;
  profileCode: string;
  perimeterType: string;
  perimeterId: string;
  perimeterName: string;
  opensProjects: boolean;
  managesProducts: boolean;
  managesEquipment: boolean;
  managesTransports: boolean;
  managesRoutings: boolean;
}

export interface CreatePersonalAccessToken {
  rightId: string;
  name: string;
  scopes: string[];
  expireDate?: string;
}

export interface CreatedPersonalAccessToken {
  token: string;
  personalAccessToken: PersonalAccessToken;
}

export const PersonalAccessTokenScopes = {
  projectsRead: 'projects:read',
  projectsWrite: 'projects:write',
  catalogsWrite: 'catalogs:write'
};
